<div class="ntt-form-field" [class.ntt-form-field--small]="size() === 'small'">
  @if (_hasLabel()) {
    <label class="ntt-form-field__label text-sm-semi-bold" [attr.for]="inputId">
      <ng-content select="ntt-label" />
      @if (required()) {
        <span class="ntt-form-field__required-asterisk">*</span>
      }
      @if (_hasLabelLeading()) {
        <span class="ntt-form-field__label-leading">
          <ng-content select="[nttLabelLeading]" />
        </span>
      }
    </label>
  }

  <div class="ntt-form-field__outer-container">
    @if (_hasTrailing()) {
      <div
        class="ntt-form-field__trailing"
        [class.ntt-form-field__trailing--disabled]="_isDisabled()"
      >
        <ng-content select="[nttTrailing]" />
      </div>
    }

    <div
      class="ntt-form-field__container"
      [class.ntt-form-field__container--invalid]="_shouldShowError()"
      [class.ntt-form-field__container--disabled]="_isDisabled()"
      [class.ntt-form-field__container--empty]="_isEmpty()"
      [class.ntt-form-field__container--touched]="_isTouched()"
      [class.ntt-form-field__container--dirty]="_isDirty()"
      [class.ntt-form-field--has-leading]="_hasLeading()"
      [class.ntt-form-field--has-trailing]="_hasTrailing()"
    >
      @if (_hasSuffix()) {
        <span
          class="ntt-form-field__suffix fg-quaternary"
          [class.ntt-form-field__suffix--error]="_shouldShowError()"
        >
          <ng-content select="[nttSuffix]" />
        </span>
      }
      <ng-content select="[nttInput]" />

      @if (_hasPrefix()) {
        <span class="ntt-form-field__prefix fg-quaternary">
          <ng-content select="[nttPrefix]" />
        </span>
      }
    </div>

    @if (_hasLeading()) {
      <div
        class="ntt-form-field__leading"
        [class.ntt-form-field__leading--disabled]="_isDisabled()"
      >
        <ng-content select="[nttLeading]" />
      </div>
    }
  </div>

  <div class="ntt-form-field__bottom-message text-sm-regular">
    @if (_shouldShowError() && showErrorMessage()) {
      <div class="ntt-form-field__error-message">
        {{ _firstErrorMessage() }}
      </div>
    } @else if (_hasHint()) {
      <ng-content select="[nttHint]" />
    }
  </div>
</div>
